export const ALL_ROLES = [
  "admin",
  "chassis-elec-qa",
  "furniture_prep",
  "builder-qc",
  "electrical-qc",
  "quality-assurance",
  "j-mould",
  "floor_and_lino_assembly",
  "wall_assembly_prep",
  "roof_assembly_prep",
  "chassis_prep",
  "doors_and_drawers_prep",
  "plumber",
  "compliance",
  "sealing",
  "cleaning",
  "line-manager-qc",
  "qa-manager-qc",
];

export const NON_ADMIN_ROLES = ALL_ROLES.filter((role) => role !== "admin");
